<script lang="ts">
  import { EmailAddress, Gender, General, Personal } from "../../../utils/Constant/Constant";
  import {usersData} from "../../../store"
  let setUsersData
  usersData.subscribe((value)=>{
    setUsersData = value
  })

</script>
<div class="email-general">
    <h6>{General}</h6>
    <p>{EmailAddress}: <span class="font-primary email_add_5">{setUsersData.email}</span></p>
    <div class="gender">
        <h6>{Personal}</h6>
        <p>{Gender}: <span>{setUsersData.gender}</span></p>
    </div>
</div>